// import React from 'react';

// const Spinner = () => {
//   return (
//     <div className="flex items-center justify-center min-h-screen bg-transparent">
//       <div className="relative w-16 h-16">
//         {/* Outer Ring */}
//         <div className="absolute inset-0 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
//         {/* Inner Pulsing Circle */}
//         <div className="absolute inset-2 bg-blue-500 rounded-full opacity-75 animate-ping"></div>
//         {/* Center Dot */}
//         <div className="absolute inset-4 bg-white rounded-full"></div>
//       </div>
//     </div>
//   );
// };

// export default Spinner;


import React from 'react';

const SpinningLogo = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div>
        <img
          src={'/title-logo.png'}
          alt="Logo"
          className="w-16 h-16 animate-spin"
        />
      </div>

      <div className="mt-4 text-lg font-semibold text-gray-700 flex items-center">
        Loading
        <div className="flex ml-2 space-x-1">
          <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></span>
          <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce delay-150"></span>
          <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce delay-300"></span>
        </div>
      </div>
    </div>
  );
};

export default SpinningLogo;

